import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo-mycing.png";

const quickLinks = [
  { name: "Servicios", href: "#servicios" },
  { name: "Proyectos", href: "#proyectos" },
  { name: "Nosotros", href: "#nosotros" },
  { name: "Contacto", href: "#contacto" },
  { name: "Trabaja con nosotros", href: "/trabaja-con-nosotros" },
  { name: "Acceso Clientes", href: "https://dash.mycing.cl/", external: true }
];

const socialLinks = [
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Linkedin, href: "#", label: "LinkedIn" }
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white relative overflow-hidden border-t border-white/10">
      {/* Liquid Blob Background Effects */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-liquid-blob" />
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-accent/20 rounded-full blur-3xl animate-liquid-blob" style={{ animationDelay: '2s' }} />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="py-8 md:py-10">
          <div className="flex flex-wrap items-center justify-between gap-6 md:gap-8 lg:gap-10">
            
            {/* Logo */}
            <div className="flex-shrink-0">
              <img 
                src={logo} 
                alt="MYCING Ingeniería Eléctrica" 
                className="h-10 md:h-12 w-auto"
              />
            </div>

            {/* Quick Links */}
            <nav className="flex flex-wrap items-center gap-4 md:gap-6">
              {quickLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noopener noreferrer" : undefined}
                  className="text-sm text-white/90 hover:text-primary transition-colors font-inter relative group"
                >
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300" />
                </a>
              ))}
            </nav>

            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="text-primary hover:text-primary/80 transition-all hover:scale-110 duration-300"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>

            {/* Contact Icons */}
            <div className="flex items-center gap-4">
              <a 
                href="tel:+56223456789" 
                className="flex items-center gap-2 text-white/90 hover:text-primary transition-colors group"
              >
                <Phone className="w-4 h-4" />
                <span className="text-sm font-inter hidden lg:inline">+56 2 2345 6789</span>
              </a>
              <a 
                href="mailto:contacto@mycing.cl" 
                className="flex items-center gap-2 text-white/90 hover:text-primary transition-colors group"
              >
                <Mail className="w-4 h-4" />
                <span className="text-sm font-inter hidden lg:inline">contacto@mycing.cl</span>
              </a>
            </div>

            {/* Copyright */}
            <div className="w-full md:w-auto text-center md:text-right">
              <p className="text-xs md:text-sm text-white/80 font-inter">
                © 2010-{currentYear} - MYCING Ltda. | Developed by{" "}
                <a 
                  href="https://gtx.cl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors underline"
                >
                  GTX Networks S.p.A.
                </a>
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
